import React, { PureComponent } from 'react'
import CSSModules from 'react-css-modules'
import { connect } from 'react-redux'

import FullOverlay from 'views/overlay/full_overlay/FullOverlay'
import Bodymovin from 'components/bodymovin/bodymovin'
import { localize } from 'helpers/translator'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import adminOnboardingActions from 'redux/actions/adminOnboardingActions'
import adminOnboardingOfferTitleSelector from 'redux/selectors/admin_onboarding/admin_onboarding_offer_title_selector'
import styles from './NoStoreDownloads.scss'

import icon from 'assets/views/admin_onboarding/clock.svg'

class NoStoreDownloads extends PureComponent {

	createAsset() {
		return (
			<Bodymovin
				path='/assets/media/animations/sharing.json'
				loop={true}
			>
				<div style={{
					width: '100%',
					height: '100%',
				}}></div>
			</Bodymovin>
		)
	}

	render() {
		return (
			<FullOverlay
				notificationIcon={icon}
				notificationText={this.props.offerTitle}
				title={localize('admin_onboarding_nostoredownloads_title')}
				strongTitle={localize('admin_onboarding_nostoredownloads_strong_title')}
				assetSource={this.createAsset()}
				assetWidth='310px'
				assetHeight='250px'
				primaryTextButton={localize('admin_onboarding_nostoredownloads_primary_text_button')}
				secondaryTextButton={localize('admin_onboarding_nostoredownloads_secondary_text_button')}
				primaryActionHandler={this.props.actions.exploreLessonsAction}
				secondaryActionHandler={this.props.actions.goToMyLibraryAction}
			/>
		)
	}
}

function mapStateToProps(state) {
	return adminOnboardingOfferTitleSelector(state)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		exploreLessonsAction: adminOnboardingActions.noStoreDownloadExploreLessons,
		goToMyLibraryAction: adminOnboardingActions.noStoreDownloadGoToMyLibrary,
	}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(NoStoreDownloads, styles, { allowMultiple: true }))
